import {get} from '../utils';

const dao = {
  queryStats: async period =>
    await get('/smb-backend/partner/dashboard/query-stats.action', {period}),
  listMetrics: async period =>
    await get('/smb-backend/partner/dashboard/list-metrics.action', {period}),
  listOrders: async date =>
    await get('/smb-backend/partner/dashboard/list-orders.action', {date}),
};

export default dao;
